<template>
    <div class="contentLogin">
        <div class="Login">
            <h4>Edad</h4>
            <b-button variant="primary" @click="ParamLogin(0)" ><span class="material-icons-outlined">bedroom_baby</span>Kids 4-6 years</b-button>
            <b-button variant="primary" @click="ParamLogin(1)" ><span class="material-icons-outlined">child_care</span>School childhood 7-12 years</b-button>
            <b-button variant="primary" @click="ParamLogin(2)" ><span class="material-icons-outlined">sports_handball</span>Teenagers 13-17 years</b-button>
            <b-button variant="primary" @click="ParamLogin(3)" ><span class="material-icons-outlined">person</span>Person +18 years</b-button>
        </div>
    </div>
</template>

<script>
import { PERFILES} from '@/assets/js/appConstants'; 
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';

export default {
    data:function(){
        return{
            API_URL: process.env.VUE_APP_API_URL,
            messageLogin:''
 
        }
    },
    computed: {
        UserId: {
            get() {
                return this.$store.state.user_id;
            },
            set(value) {
                this.$store.commit('mutateUserId', value);
            }
        },
        User: {
            get() {
                return this.$store.state.user;
            },
            set(value) {
                this.$store.commit('mutateUser', value);
            }
        },
        
    },
  methods: {
    ParamLogin(params) {
      //this.$store.commit("mutateLoginNoAccess", false);
      let user = {};
      switch (params) {
        
        case 0:
          //this.$store.commit("mutateGroupPersonId", 2);
          //this.$store.commit("mutateGroupId", 3);
          //this.$store.commit("mutatePersonStudentId", 5);
          //this.$store.commit("mutateAge", 5);
          user = {
            email:'lcampos@prueba.pe',
            password:'123456',
            personsTypeId:PERFILES.ALUMNO
          }
          break;
        case 1:
          //this.$store.commit("mutateGroupPersonId", 3);
          //this.$store.commit("mutateGroupId", 4);
          //this.$store.commit("mutatePersonStudentId", 6);
          //this.$store.commit("mutateAge", 8);
          user = {
            email:'jpalomino@prueba.pe',
            password:'123456',
            personsTypeId:PERFILES.ALUMNO
          }
          break;
        case 2:
          //this.$store.commit("mutateGroupPersonId", 4);
          //this.$store.commit("mutateGroupId", 5);
          //this.$store.commit("mutatePersonStudentId", 7);
          //this.$store.commit("mutateAge", 16);
          user = {
            email:'lpardo@prueba.pe',
            password:'123456',
            personsTypeId:PERFILES.ALUMNO
          }
          break;
        case 3:
          //this.$store.commit("mutateGroupPersonId", 1);
          //this.$store.commit("mutateGroupId", 1);
          //this.$store.commit("mutatePersonStudentId", 1);
          //this.$store.commit("mutateAge", 23);
          user = {
            email:'jorge.prado@itsight.pe',
            password:'123456',
            personsTypeId:PERFILES.ALUMNO
          }
          break;
      }

      this.Login(user);
      //this.$router.replace({name:"/edad"})
      // this.$router.push({
      //   name: "compra"
      // });
    },
    Login: function(user) {
			 
			baseInstanceAxios
				.post(this.API_URL + `/resources/Persons/ValidateLogin`, user)
				.then(response => {
					if (response.data != null) {
						if(response.data.entity != null){//LOGUEADO CON EXITO
              this.UserId = response.data.entity.id;
              this.User = {
                "id": response.data.entity.id,
                "firstName": response.data.entity.firstName,
                "lastName": response.data.entity.lastName,
                "strFullName": response.data.entity.strFullName,
                "email": response.data.entity.email,
                "birthDate": response.data.entity.birthDate,
                "age": parseInt(response.data.entity.strAge,10),
                "photo": response.data.entity.photo,
                "personsTypeId":response.data.entity.personsTypeId,
                "personStudentId": response.data.entity.personStudentId,
                "isResponseReceived": response.data.entity.isResponseReceived,
              }
              this.$store.dispatch("updateFlagPostulant",response.data.entity.flagPostulant)
              this.$store.dispatch("updateFlagValidateCalifications",response.data.entity.flagValidateCalifications)
              this.$router.replace({name:"/"})
						}else{
              this.messageLogin = response.data.message;
              this.$bvToast.show("toast-login-error");
            }
					}
				});
		},
  },
};
</script>